t = require('views/internal/teacup-with-helpers')('org_prefs_vis')

module.exports = ->
  t.div { style: 'margin: 12px 0 0;' }, ->

    t.p ->
      t.format 'who-can-create-public-boards'

    t.ul '.pop-over-list.checkable.left-check.normal-weight', { 'data-vis': 'public' }, ->

      t.li { class: t.mustacheBlock('boardVisibilityRestrict_public_org', (-> 'active')) }, ->
        t.a { href: '#', 'data-restriction': 'org' }, ->
          t.format 'any-organization-member'

      t.li { class: t.mustacheBlock('boardVisibilityRestrict_public_admin', (-> 'active')) }, ->
        t.a { href: '#', 'data-restriction': 'admin' }, ->
          t.format 'only-organization-admins'

      t.li { class: t.mustacheBlock('boardVisibilityRestrict_public_none', (-> 'active')) }, ->
        t.a { href: '#', 'data-restriction': 'none' }, ->
          t.format 'nobody'

  t.hr()

  t.div { style: 'margin: 12px 0 0;' }, ->

    t.p ->
      t.format 'who-can-create-organization-visible-boards'

    t.ul '.pop-over-list.checkable.left-check.normal-weight', { 'data-vis': 'org' }, ->

      t.li { class: t.mustacheBlock('boardVisibilityRestrict_org_org', (-> 'active')) }, ->
        t.a { href: '#', 'data-restriction': 'org' }, ->
          t.format 'any-organization-member'

      t.li { class: t.mustacheBlock('boardVisibilityRestrict_org_admin', (-> 'active')) }, ->
        t.a { href: '#', 'data-restriction': 'admin' }, ->
          t.format 'only-organization-admins'

      t.li { class: t.mustacheBlock('boardVisibilityRestrict_org_none', (-> 'active')) }, ->
        t.a { href: '#', 'data-restriction': 'none' }, ->
          t.format 'nobody'

  t.hr()

  t.div { style: 'margin: 12px 0 0;' }, ->

    t.p ->
      t.format 'who-can-create-private-boards'

    t.ul '.pop-over-list.checkable.left-check.normal-weight', { 'data-vis': 'private' }, ->

      t.li { class: t.mustacheBlock('boardVisibilityRestrict_private_org', (-> 'active')) }, ->
        t.a { href: '#', 'data-restriction': 'org' }, ->
          t.format 'any-organization-member'

      t.li { class: t.mustacheBlock('boardVisibilityRestrict_private_admin', (-> 'active')) }, ->
        t.a { href: '#', 'data-restriction': 'admin' }, ->
          t.format 'only-organization-admins'

      t.li { class: t.mustacheBlock('boardVisibilityRestrict_private_none', (-> 'active')) }, ->
        t.a { href: '#', 'data-restriction': 'none' }, ->
          t.format 'nobody'




// WEBPACK FOOTER //
// ./app/scripts/views/templates/org_prefs_vis.coffee